// extracted by mini-css-extract-plugin
module.exports = {"game-board":"TicTacToe_game-board__1_FKr","box":"TicTacToe_box__2HSGp"};